<template>
  <div>
    <back :title="titlename"></back>
    <!-- 预约办 -->
    <van-form>
      <van-field name="姓名" label="姓名" :value="name" readonly/>
      <van-field name="所属社区" label="所属社区" :value="sq" readonly/>
      <van-field name="预约网络点" label="预约网络点" :value="wg" readonly/>
      <van-field name="联系电话" label="联系电话" :value="phone" readonly/>
      <div class="textarea">
        <p>办理事项具体说明</p>
        <textarea :value="content" name="" id="" readonly></textarea>
      </div>
      <van-field name="具体地址" label="具体地址" :value="address" readonly/>
      <van-field name="上门时间" label="上门时间" :value="time" readonly/>
      <img src="" alt="" style="width: 2rem;height: 2rem;padding: 10px 16px;">
      <div style="margin: 16px;display: flex;">
        <van-button round block type="info" class="true" @click="success">审核通过</van-button>
        <van-button round block type="info" class="false">审核不通过</van-button>
      </div>

    </van-form>
  </div>

</template>

<script>
  import { Form,Toast } from 'vant'
  import $ from 'jquery'
  export default {
    data() {
      return {
        titlename: "上门办业务审核",
        name:"2",
        sq:"1",
        phone:"",
        address:"",
        time:"",
        content:"1",
        wg:""
      };
    },
    created:function(){
      //this.getperinfo()
    },
    methods: {
      // 获取个人信息
      getperinfo(){
        this.$http.post(this.$store.state.host+"/interface/getUser",{openid:this.$store.state.openId},{emulateJSON:true})
        .then(res=>{
          //发送成功
          console.log(res)
          if(res.body.code==0){
            this.name=res.body.userPd.realname
            this.phone=res.body.userPd.phone
          }

          //if()
        },res=>{
           //发送失败
        })
      },
      success(){
        Toast.load("123")
          // Toast.loading({
          //   message: '审核提交中...',
          //   forbidClick: true,
          //   overlay:true,
          //   duration:0
          // })
          //Toast.success('成功文案')
          //Toast.loading()
          // this.$http.post("",{},{}).then(res=>{

          // },res=>{

          // })

      },
    },
  }
</script>

<style lang="less" scoped>
  /deep/.van-overlay{background-color: white !important;}
  /deep/.van-form{
    .van-button--info{
      background-color: #f28033;
      border: 1px solid #f28033;
      border-radius: 5px;
    }
    .van-cell{
      font-size: .26rem;
      }
    .textarea{
      font-size: .26rem;
      padding: 10px 16px;
      color: #646566;
      textarea{
        width: 98%;
        height: 150px;
        border-color: #e5e5e5;
        color: #999999;
        margin-top: 16px;
        padding: 10px 1%;
      }
    }
  }
  /deep/.van-field__control{
    text-align: right;
  }
.false{
  background-color: #339af2 !important;
  border: 1PX solid #339af2 !important;
  margin-left: .1REM;
}

</style>



// WEBPACK FOOTER //
// src/pages/verifyinfo.vue